import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ViewerActorModel } from 'src/app/models/viewer/viewer-actor.model';


export const ActionSummaryModalOptions: NgbModalOptions = {
  keyboard: false,
  centered: true,
  size: 'lg'
};

@Component({
    templateUrl: './action-summary.modal.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActionSummaryModal {

  /** */
  @Input() myActors!: ViewerActorModel[];
  @Input() documents!: any[];
  @Input() requestStatus!: string;
  @Input() requestName!: string;

  get allActorsCompleted(): boolean {
    return this.myActors && this.myActors.every(actor => actor.actionCompleted);
  }
  constructor(public activeModal: NgbActiveModal) {
  }

  close() {
    this.activeModal.close();
  }
}
